import type { RetryOrderTrackingInput } from '@repo/api-contracts';
import { useInvalidateOrders } from '@/entities/order';
import { trpc } from '@/shared/api';

/**
 * 다시 추적(orderManagement.retryTracking, 주문 설계 §5-4·§7-2). 입력에 주문 id 가 없어(서버는 결과를 돌려주지 않는다) 화면의 주문 id 를 받아, 성공하면 그 주문의 상세·목록과
 * 주문 상태를 보여 주는 견적 화면을 다시 불러온다. 실패는 서버 오류를 그대로 던진다 — 문구와 상태 충돌 재조회는 화면이 정한다.
 */
export const useRetryTracking = (
  orderId: string,
): ((input: RetryOrderTrackingInput) => Promise<void>) => {
  const orders = useInvalidateOrders();
  const mutation = trpc.orderManagement.retryTracking.useMutation();

  return async (input) => {
    await mutation.mutateAsync(input);
    await Promise.all([orders.detail(orderId), orders.list(), orders.quotes()]);
  };
};
